module.exports = __webpack_public_path__ + "static/Resin Venners smile after-457ad1c80f7e6a64b965fb384fc144fa.jpg";